export default __webpack_public_path__ + "static/media/visuel-home-zoom-3-min.b319bf6c.jpg";